<div class="section-topup breadcrum-topup">
  <p>{{ walletName }} > <span i18n="@@topup-topup">Top Up</span></p>
</div>
<div class="section-currency section-topup p-3 bg-white mt-1">
  @if (shouldDownload && !isFailed) {
    <div class="container-invoice" (click)="downloadInvoice()">
      <span class="download-invoice btn-wallet">
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.7502 1.66675C10.7502 1.25253 10.4144 0.916748 10.0002 0.916748C9.58598 0.916748 9.25019 1.25253 9.25019 1.66675V8.18942L8.03052 6.96975C7.73763 6.67686 7.26276 6.67686 6.96986 6.96975C6.67697 7.26264 6.67697 7.73752 6.96986 8.03041L9.46986 10.5304C9.61051 10.6711 9.80128 10.7501 10.0002 10.7501C10.1991 10.7501 10.3899 10.6711 10.5305 10.5304L13.0305 8.03041C13.3234 7.73752 13.3234 7.26264 13.0305 6.96975C12.7376 6.67686 12.2628 6.67686 11.9699 6.96975L10.7502 8.18942V1.66675ZM6.94483 2.58332L7.08201 2.58341H7.29186C7.70607 2.58341 8.04186 2.9192 8.04186 3.33341C8.04186 3.74763 7.70607 4.08341 7.29186 4.08341H7.08201C6.11903 4.08341 5.85911 4.09772 5.6609 4.18099C5.45598 4.26709 5.27772 4.40627 5.1445 4.58419C5.01563 4.75629 4.93872 5.00497 4.70516 5.9392L3.49112 10.7954L3.46083 10.9167H6.66686C6.91762 10.9167 7.1518 11.0421 7.2909 11.2507L8.03306 12.364C8.37942 12.8835 8.47785 13.0193 8.59001 13.1155C8.72822 13.234 8.89065 13.321 9.06596 13.3702C9.20824 13.4102 9.37579 13.4167 10.0002 13.4167C10.6246 13.4167 10.7921 13.4102 10.9344 13.3702C11.1097 13.321 11.2722 13.234 11.4104 13.1155C11.5225 13.0193 11.621 12.8835 11.9673 12.364L12.7095 11.2507C12.8486 11.0421 13.0828 10.9167 13.3335 10.9167H16.5396L16.5093 10.7954L15.2952 5.9392C15.0617 5.00497 14.9847 4.75629 14.8559 4.58419C14.7227 4.40627 14.5444 4.26709 14.3395 4.18099C14.1413 4.09772 13.8814 4.08341 12.9184 4.08341H12.7085C12.2943 4.08341 11.9585 3.74763 11.9585 3.33341C11.9585 2.9192 12.2943 2.58341 12.7085 2.58341H12.9184L13.0556 2.58332C13.813 2.58258 14.4061 2.58199 14.9205 2.79809C15.3713 2.9875 15.7635 3.2937 16.0566 3.68512C16.391 4.13171 16.5343 4.70725 16.7173 5.44229L16.7504 5.5754L17.9645 10.4316L17.9714 10.4591C18.0378 10.7249 18.0807 10.8963 18.1108 11.0713C18.1747 11.4426 18.1942 11.8203 18.1688 12.1962C18.1569 12.3733 18.1319 12.5482 18.0932 12.8193L18.0931 12.8194L18.0931 12.8195L18.0891 12.8476L18.0711 12.9735C17.9103 14.1013 17.8074 14.8223 17.5399 15.4256C16.9672 16.7171 15.8493 17.6867 14.4898 18.071C13.8547 18.2505 13.1264 18.2503 11.9872 18.2501L11.86 18.2501H8.1404L8.01322 18.2501C6.87398 18.2503 6.14568 18.2505 5.51063 18.071C4.1511 17.6867 3.03319 16.7171 2.46048 15.4256C2.19296 14.8223 2.09012 14.1013 1.92924 12.9735L1.91127 12.8476L1.90727 12.8196C1.8685 12.5483 1.8435 12.3734 1.83156 12.1962C1.80621 11.8203 1.82569 11.4426 1.88959 11.0713C1.9197 10.8963 1.96256 10.7249 2.02904 10.459L2.0359 10.4316L3.24995 5.5754L3.28313 5.44229C3.46612 4.70725 3.6094 4.13171 3.9438 3.68512C4.23689 3.2937 4.62906 2.9875 5.07989 2.79809C5.59425 2.58199 6.18735 2.58258 6.94483 2.58332ZM3.39619 12.6355C3.38382 12.5489 3.37365 12.4774 3.36523 12.4167H6.26547L6.78499 13.196L6.83325 13.2685C7.10811 13.6814 7.32407 14.0058 7.61336 14.254C7.9174 14.5148 8.27476 14.706 8.66043 14.8143C9.02739 14.9174 9.41711 14.9171 9.91313 14.9168L10.0002 14.9167L10.0873 14.9168C10.5833 14.9171 10.973 14.9174 11.34 14.8143C11.7256 14.706 12.083 14.5148 12.387 14.254C12.6763 14.0058 12.8923 13.6814 13.1671 13.2685L13.2154 13.196L13.7349 12.4167H16.6351C16.6267 12.4774 16.6166 12.5489 16.6042 12.6355C16.4189 13.9324 16.3409 14.4292 16.1687 14.8175C15.7768 15.7012 15.0119 16.3646 14.0817 16.6275C13.6729 16.7431 13.1701 16.7501 11.86 16.7501H8.1404C6.8303 16.7501 6.32744 16.7431 5.91865 16.6275C4.98845 16.3646 4.22357 15.7012 3.83171 14.8175C3.65951 14.4292 3.58147 13.9324 3.39619 12.6355Z"
            fill="#FFFFFF"
          />
        </svg>
        <span>{{ isCargoWallet ? topupRequestTxt : invoiceTxt }}</span>
        @if (isLoading) {
          <div class="lds-dual-ring"></div>
        }
      </span>
    </div>
  }
  @if (!isFailed) {
    <cai-success-message
      [isShow]="true"
      [title]="'THANK YOU!'"
    ></cai-success-message>
  }
  @if (isFailed) {
    <div class="text-center">
      <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="64" cy="64" r="64" fill="#FCF4F5" />
        <circle cx="64" cy="64" r="27.5" stroke="#FF4453" stroke-width="3" />
        <path d="M57 70.5L71.5 57" stroke="#FF4453" stroke-width="3" />
        <path d="M57.5 57L71 71.5" stroke="#FF4453" stroke-width="3" />
      </svg>
      <span class="failed-message__title" i18n="@@topup-thankyou-failed-status"
        >The transaction has failed</span
      >
    </div>
  }
  @if (isFailed) {
    <p class="thankyou-text mt-3" i18n="@@topup-thankyou-try-again">
      The transaction has failed please try again.
    </p>
  }
  @if (!isFailed) {
    <p class="thankyou-text" i18n="@@topup-thankyou-prepayment-registered">
      Your Prepayment request has been successfully registered.
    </p>
  }
  @if (!isFailed) {
    <p class="thankyou-text" i18n="@@topup-thankyou-download-invoice">
      You can download the Prepayment
      {{ lowerInvoiceTxt }} from this page by clicking on the Download my
      {{ lowerInvoiceTxt }} button. You should submit this
      {{ lowerInvoiceTxt }} to your accounting department in order to perform
      the bank transfer.
    </p>
  }

  @if (!isFailed) {
    <p class="thankyou-text" i18n="@@topup-thankyou-balance-update">
      The CargoWALLET balance will be topped up as soon as we receive the funds.
    </p>
  }
  @if (!isFailed) {
    <p class="thankyou-text" i18n="@@topup-thankyou-transaction-status">
      You can check the status of the transaction on the CargoWALLET transaction
      page.
    </p>
  }
  <p class="thankyou-text" i18n="@@topup-thankyou-recieve-invoice">
    Remember you can withdraw your money anytime by contacting our customer
    service team at
    <a href="mailto:support+wallet@cargoai.co">support+wallet&#64;cargoai.co</a>
  </p>
  <p class="thankyou-text" i18n="@@topup-thankyou">
    Thank you for using CargoAI
  </p>
</div>
<a class="back-button btn-wallet mb-3 mb-sm-0" [href]="walletBaseUrl">
  {{ isFailed ? "BACK TO TOP UP" : "BACK TO WALLET MANAGEMENT" }}
</a>
